module.exports = function getResource(label, vars = []) {
    const resources = {
        addGiftMessage: 'Ajouter un message',
        new: 'Nouveauté',
        giftMessageAdded: 'Message cadeau ajouté',
        edit: 'Modifier',
        remove: 'Supprimer'
    };

    return resources[label];
};
